/*
  BotechProvider.jsx
*/

// Npm.
import React from 'react';

// Contexts.
import BotechContext from '../../contexts/BotechContext';

/**
 * Provides app-wide config and helpers.
 */
export default function BotechProvider({ botech, children }) {
  return (
    <BotechContext.Provider value={botech}>
      { children }
    </BotechContext.Provider>
  );
}
